import React from 'react';
import { PopUp, Button } from 'geniebook-ui/dist';
import AICommentIllustration from '@assets/illustration/AIComment';
import { useViewWidth } from '@utils/helpers/viewWidth';
import { useNavigate } from 'react-router-dom';

const breakpoint = require('geniebook-ui/dist/themes/breakpoint');

type AICommentPopupProps = {
  hide_ai_comment_popup: () => void;
  subject_name: string;
};

const NewAICommentPopup = ({
  hide_ai_comment_popup,
  subject_name,
}: AICommentPopupProps) => {
  const viewWidth = useViewWidth();
  const navigate = useNavigate();

  const ButtonGroup = () => {
    return (
      <div className={'w-full'}>
        <Button
          className="mb-2"
          onClick={() => {
            localStorage.setItem('has_shown_new_ai_comment', '1');
            hide_ai_comment_popup();

            navigate({
              pathname: '/' + subject_name + '/worksheets',
              search: 'completed_tab=1',
            });
          }}
        >
          Go to worksheet
        </Button>
      </div>
    );
  };

  return (
    <PopUp
      img={<AICommentIllustration className="w-full mx-auto mb-4" />}
      title="Have you reviewed comments on your answers yet?"
      description="Our AI-generated comments are available for incorrect answers after marking, helping you learn and improve."
      buttonGroup={ButtonGroup()}
      onClose={() => {}}
      disableBodyScroll={true}
      width={viewWidth < breakpoint.md ? `${viewWidth - 30}px` : '400px'}
    />
  );
};

export default NewAICommentPopup;
